import styles from './leftRail.module.css';

/**
 * Hairline rule with centred text — mirrors trusstor's
 * `LineDividerWithText`. Used by `SafetyEventsTab` to label the LIVE
 * and EVENTS LOG subsections.
 */
export function LineDivider({ text }: { text: string }) {
  return (
    <div className={styles.lineDivider} role="separator">
      <span className={styles.lineDividerText}>{text}</span>
    </div>
  );
}
